import { ReactNode } from 'react';
import { Button as ReactstrapButton } from 'reactstrap';
import { uiSurface } from './uiSurface';
import styled from 'styled-components';

type ButtonVariant = 'primary' | 'secondary';

interface IButtonProps {
  variant?: ButtonVariant;
  fullWidth?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  // reactstrap renders an <a> when href is set
  href?: string;
  target?: string;
  rel?: string;
  className?: string;
  children: ReactNode;
  'data-cy'?: string;
}

// New-design pill button in the design-element colours: primary = ink filled, secondary =
// outlined on the surface. Both keep an ink border.
const StyledButton = styled(ReactstrapButton)<{ $primary: boolean; $fullWidth: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px 10px;
  font-size: 16px;
  border-radius: 24px;
  height: 47px;
  max-height: 47px;
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};
  flex: ${({ $fullWidth }) => ($fullWidth ? '1 1 0' : '0 0 auto')};
  background-color: ${({ $primary }) => ($primary ? uiSurface.ink : uiSurface.background)};
  color: ${({ $primary }) => ($primary ? uiSurface.background : uiSurface.ink)};
  border: 1px solid ${uiSurface.ink};
  transition: background-color 0.2s ease, color 0.2s ease;

  /* primary inverts to the surface on hover; secondary only lifts (never turns ink) */
  &:hover,
  &:focus {
    background-color: ${({ $primary }) => ($primary ? uiSurface.background : uiSurface.raised)};
    color: ${uiSurface.ink};
    border-color: ${uiSurface.ink};
  }
`;

export const Button = ({
  variant = 'secondary',
  fullWidth = false,
  children,
  ...rest
}: IButtonProps) => (
  <StyledButton $primary={variant === 'primary'} $fullWidth={fullWidth} {...rest}>
    {children}
  </StyledButton>
);
